export default function inputLogin() {
	const inputs = document.querySelectorAll(`[js-focus]`);
	if (!inputs) return;

	inputs.forEach((input) => {
		input.addEventListener("focus", (event) => toggleClass(input));
		input.addEventListener("focusout", (event) => toggleClass(input));
	});

	function toggleClass(element) {
		const target = element.getAttribute("margin-target");
		const targetElement = document.querySelector(target);

		const value = element.value;
		const isActive = document.activeElement == element;

		if (value || isActive) {
			targetElement.classList.remove("-mt-24");
		} else {
			targetElement.classList.add("-mt-24");
		}
	}
}
